// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bw246","content":"styles_content__2Yxc1"};